import { $, $$ } from 'utils/dom';

const creditButtons = $$('.credit__button');

if (creditButtons.length) {
  creditButtons.forEach(creditButton => {
    const creditFigcaption = creditButton.nextElementSibling;
    const buttonClose = $('.credit__button-close', creditFigcaption);
    if (creditButton) {
      creditButton.addEventListener('click', event => {
        creditFigcaption.classList.add('is-active');
        creditButton.classList.add('is-active');
      });
    }
    if (buttonClose) {
      buttonClose.addEventListener('click', event => {
        creditFigcaption.classList.remove('is-active');
        creditButton.classList.remove('is-active');
      });
    }
  });
}
